import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Shadow } from '../types/Shadow';

export function composeShadowClasses(shadow: Adaptive<Shadow>): string {
    if (typeof shadow === 'object') {
        return clsx(
            shadow.base && `shadow-${shadow.base}`,
            shadow.sm && `sm:shadow-${shadow.sm}`,
            shadow.md && `md:shadow-${shadow.md}`,
            shadow.lg && `lg:shadow-${shadow.lg}`,
            shadow.xl && `xl:shadow-${shadow.xl}`,
            shadow['2xl'] && `2xl:shadow-${shadow['2xl']}`
        );
    }

    return `shadow-${shadow}`;
}
